import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ScanResultBox} from './ScanResultBox';
import {ScanResultBoxData} from '../../../connectivity-guru.contracts';
import {observer} from 'mobx-react';

interface ScanResultBoxesProps {
    boxes: ScanResultBoxData[];
    getIconColor: (label: number) => string;
}

@observer
export class ScanResultBoxes extends TechseeBaseComponent<ScanResultBoxesProps> {
    renderInternal() {
        const {boxes, getIconColor} = this.props;

        return (
            <div className='scan-box-wrapper'>
                {boxes.map((box, index) => (
                    <div key={index} className='scan-box'>
                        <ScanResultBox scanResultBoxData={box} getIconColor={getIconColor} />
                    </div>
                ))}
            </div>
        );
    }
}
